import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import styles from './inspirecommila.module.scss';

import hero from './src/hero.jpeg';
import sobre from './src/sobre.jpeg';
import donna from './src/donna.jpeg';
import fly from './src/fly.jpeg';

const INSTAGRAM_URL = 'https://www.instagram.com/inspirecommila?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==';

type Cupom = {
    id: 'donna' | 'fly';
    marca: string;
    codigo: string;
    rotulo: string;
    instrucao?: string;
    site: string;
    instagram: string;
    foto: string;
    nota: string;
};

const CUPONS: Cupom[] = [
    {
        id: 'donna',
        marca: 'Donna Carioca',
        codigo: 'INSPIRECOMMILA',
        rotulo: 'Código de vendedor',
        instrucao:
            'No site, use o campo Código de vendedor, na parte de baixo. Se colocar no cupom de desconto, o benefício não ativa.',
        site: 'https://www.donnacarioca.com.br',
        instagram: 'https://www.instagram.com/donnacarioca?igsi=OGlvbGxkZHJuNXBw',
        foto: donna,
        nota: 'Moda fitness',
    },
    {
        id: 'fly',
        marca: 'Fly Basic',
        codigo: 'INSPIRE10',
        rotulo: 'Cupom de desconto',
        site: 'https://www.flybasic.com.br',
        instagram: 'https://www.instagram.com/flybasic?igsi=MW8zczZjOWJkajFwaA==',
        foto: fly,
        nota: 'Essenciais',
    },
];

const CAMINHOS = [
    {
        titulo: 'Comunidade LÚMINA',
        linha: 'Um ano de processo, não de consumo',
        to: '/inspirecommila/lumina',
    },
    {
        titulo: 'Imersão RAIZ',
        linha: '4 horas · 7 de novembro · R$ 97',
        to: '/inspirecommila/raiz',
    },
    {
        titulo: 'Acompanhamento individual',
        linha: 'Um processo só seu',
        to: '/inspirecommila/mentoria',
    },
    {
        titulo: 'Essência do Lar',
        linha: 'Encontro presencial para mulheres',
        to: '/inspirecommila/essencia-do-lar',
    },
    {
        titulo: 'Mulheres que se amam',
        linha: 'Livro digital',
        to: '/inspirecommila/livro',
    },
];

const Inspirecommila: React.FC = () => {
    const [cupomAtivo, setCupomAtivo] = useState<Cupom | null>(null);
    const [copiado, setCopiado] = useState(false);

    useEffect(() => {
        if (!cupomAtivo) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setCupomAtivo(null);
        };
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prev;
            window.removeEventListener('keydown', onKey);
        };
    }, [cupomAtivo]);

    const copiar = async () => {
        if (!cupomAtivo) return;
        try {
            await navigator.clipboard.writeText(cupomAtivo.codigo);
            setCopiado(true);
            window.setTimeout(() => setCopiado(false), 1800);
        } catch {
            setCopiado(false);
        }
    };

    return (
        <div className={styles.inspirecommila}>
            <div className={styles.sheet}>
                <div className={styles.topbar}>
                    <div className={styles.brand}>
                        <span>Inspire com</span>
                        <strong>Mila</strong>
                    </div>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.ig}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="18" color="#e6dfd4" />
                    </a>
                </div>

                <figure className={styles.hero}>
                    <img src={hero} alt="Mila" />
                    <figcaption>
                        <em>identidade, fé</em>
                        <span>e processo.</span>
                    </figcaption>
                </figure>

                <p className={styles.lead}>
                    Para mulheres que não querem só consumir conteúdo. Querem olhar para a própria história e
                    caminhar com direção.
                </p>

                <div className={styles.indice} aria-label="Caminhos">
                    {CAMINHOS.map((item) => (
                        <Link key={item.to} to={item.to} className={styles.entrada}>
                            <span className={styles.entradaTexto}>
                                <strong>{item.titulo}</strong>
                                <small>{item.linha}</small>
                            </span>
                            <span className={styles.seta} aria-hidden>
                                →
                            </span>
                        </Link>
                    ))}
                </div>

                <div className={styles.retrato}>
                    <div className={styles.retratoFoto}>
                        <img src={sobre} alt="Mila de blazer mostarda" />
                    </div>
                    <div className={styles.retratoTexto}>
                        <p className={styles.eyebrow}>Sobre</p>
                        <p>
                            relacionamentos e fé prática. Sem fórmula pronta. Com processo.
                        </p>
                    </div>
                </div>

                <div className={styles.cupons}>
                    <div className={styles.cuponsHead}>
                        <p className={styles.eyebrow}>Parcerias</p>
                        <h2>Cupons</h2>
                    </div>
                    <div className={styles.tickets}>
                        {CUPONS.map((c) => (
                            <button
                                key={c.id}
                                type="button"
                                className={styles.ticket}
                                onClick={() => {
                                    setCopiado(false);
                                    setCupomAtivo(c);
                                }}
                            >
                                <img src={c.foto} alt="" />
                                <span>
                                    <small>{c.nota}</small>
                                    <strong>{c.marca}</strong>
                                </span>
                            </button>
                        ))}
                    </div>
                </div>

                <div className={styles.fecho}>
                    <p>“A mulher sábia edifica a sua casa.”</p>
                    <span>Provérbios 14:1</span>
                </div>
            </div>

            {cupomAtivo ? (
                <div
                    className={styles.overlay}
                    onClick={() => setCupomAtivo(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="inspirecommila-cupom-titulo"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.fechar}
                            onClick={() => setCupomAtivo(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.eyebrow}>{cupomAtivo.rotulo}</p>
                        <h2 id="inspirecommila-cupom-titulo">{cupomAtivo.marca}</h2>
                        <div className={styles.voucher}>
                            <span>{cupomAtivo.rotulo}</span>
                            <strong>{cupomAtivo.codigo}</strong>
                            <button type="button" onClick={copiar}>
                                {copiado ? 'Copiado' : 'Copiar'}
                            </button>
                        </div>
                        {cupomAtivo.instrucao ? (
                            <p className={styles.instrucao}>{cupomAtivo.instrucao}</p>
                        ) : null}
                        <a href={cupomAtivo.site} target="_blank" rel="noopener noreferrer">
                            Ir para o site
                        </a>
                        <a
                            href={cupomAtivo.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkSecundario}
                        >
                            Instagram da marca
                        </a>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Inspirecommila;
